import { STAKING_ACTION } from '../../constants/actions'

const resetStakingState = () => ({
  type: STAKING_ACTION.RESET_STATE
})

const changeStakingState = (property, value) => ({
  type: STAKING_ACTION.CHANGE_STATE,
  payload: {
    property,
    value
  }
})

const changeStakingInfoState = (stakedQBX, endTime) => ({
  type: STAKING_ACTION.CHANGE_STAKE_INFO,
  payload: { stakedQBX, endTime }
})

const getStakingReward = (address) => ({
  type: STAKING_ACTION.GET_STAKING_REWARD,
  payload: { address }
})

const claimStakingReward = (payload) => ({
  type: STAKING_ACTION.CLAIM_STAKING_REWARD,
  payload
})

const getSymbolReward = () => ({
  type: STAKING_ACTION.GET_SYMBOL_REWARD
})

const claimSymbolReward = () => ({
  type: STAKING_ACTION.CLAIM_SYMBOL_REWARD
})

const startQBXPricePolling = () => ({
  type: STAKING_ACTION.START_QBX_PRICE_POLLING
})

const stopQBXPricePolling = () => ({
  type: STAKING_ACTION.STOP_QBX_PRICE_POLLING
})

const getUserTier = () => ({
  type: STAKING_ACTION.GET_USER_TIER
})

export {
  resetStakingState,
  changeStakingState,
  changeStakingInfoState,
  getStakingReward,
  claimStakingReward,
  getSymbolReward,
  claimSymbolReward,
  startQBXPricePolling,
  stopQBXPricePolling,
  getUserTier
}
